module.exports = __webpack_public_path__ + "static/media/207-Kuchen_ID_36.0b8f5038.mp3";